import { createReducer, on } from '@ngrx/store';
import { MemberGroupApiActions, MemberGroupListActions, GroupApiActions } from './member-group.actions';
import { adapter, createMemberGroupFromParent, initialstate, selectGroupIdFromParent } from './member-group.state';

export const memberGroupReducer = createReducer(
  initialstate,
  on(MemberGroupApiActions.memberGroupsLoaded, (state, { groups }) => adapter.upsertMany(groups, state)),
  on(MemberGroupListActions.memberGroupsDeleted, (state, { group }) =>
    adapter.removeOne(selectGroupIdFromParent(group), state)
  ),
  on(MemberGroupListActions.memberGroupsAdded, (state, { group, groupToAdd }) =>
    adapter.addOne(createMemberGroupFromParent(groupToAdd, group), state)
  ),
  on(GroupApiActions.groupDeleted, (state, { group }) => {
    const ids: string[] = [];
    selectMemberGroupIds(state).forEach((x: string | number) => {
      if (x.toString().includes(group.id)) {
        ids.push(x.toString());
      }
    });
    return adapter.removeMany(ids, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMemberGroupIds = selectIds;

export const selectMemberGroupEntities = selectEntities;

export const selectAllGroups = selectAll;
